import { useEffect, useRef } from 'react';

import {
  analyticsService,
  type ShippingQuoteSource,
} from 'services/analytics/analyticsService';

export const useShippingAbandonTracking = (
  source: ShippingQuoteSource,
  shippingPrice: number | null,
  subscriptionPlan?: string,
) => {
  const shippingPriceRef = useRef(shippingPrice);
  const advanceClickedRef = useRef(false);

  useEffect(() => {
    shippingPriceRef.current = shippingPrice;
  }, [shippingPrice]);

  useEffect(() => {
    const pageEnteredAt = Date.now();

    const trackAbandonIfNeeded = () => {
      if (
        shippingPriceRef.current === null ||
        advanceClickedRef.current
      ) {
        return;
      }

      analyticsService.trackShippingAbandon({
        source,
        shippingPrice: shippingPriceRef.current,
        timeOnPageSeconds: Math.round((Date.now() - pageEnteredAt) / 1000),
        subscriptionPlan,
      });
    };

    window.addEventListener('pagehide', trackAbandonIfNeeded);

    return () => {
      window.removeEventListener('pagehide', trackAbandonIfNeeded);
      trackAbandonIfNeeded();
    };
  }, [source, subscriptionPlan]);

  const markAdvanceClicked = () => {
    advanceClickedRef.current = true;
  };

  return { markAdvanceClicked };
};
